import { render, staticRenderFns } from "./LockersPanel.vue?vue&type=template&id=37bc3f79&scoped=true"
import script from "./LockersPanel.vue?vue&type=script&lang=js"
export * from "./LockersPanel.vue?vue&type=script&lang=js"
import style0 from "./LockersPanel.vue?vue&type=style&index=0&id=37bc3f79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bc3f79",
  null
  
)

export default component.exports